
<div class="location-comp" (click)="$event.stopPropagation()">
  <div class="component-wrapper" [class.disabled]="completeSubmission">
    <section>
        <h4 class="help-header">Click & Collect Store</h4>
        <i class="material-icons closebutton-pullfloat-right btn-close" (click)="close()"  title="close">close</i>
    </section>
    <span class="help-body-text">Store set to</span>

    <div class="store-name">{{ currentStore?.out_whse_description }}</div>
    <div class="address">{{ currentStore?.out_whse_address01 }} {{ currentStore?.out_whse_address02 }} {{ currentStore?.out_whse_address03 }} {{ currentStore?.out_whse_address04 }} {{ currentStore?.out_whse_state }} {{ currentStore?.out_whse_postcode }}</div>

    <form class="form-horizontal" id="question-form">
        <ng-container *ngIf="!chooseMode">
            <span class="screenShot"><a class="change-store" (click)="chooseLocation()">Change store</a></span>
        </ng-container>
        <ng-container *ngIf="chooseMode">

            <!-- <div class="gloSearchInputGroup" id="globalSearch">
                <input class="form-control mr-sm-2 searchbar searchInput" type="text" placement="bottom"
                    placeholder="Search keywords" onfocus="this.placeholder=''" onblur="this.placeholder='Search keywords'"
                    [(ngModel)]="searchField" (keyup.enter)="search(searchField)">
                <div class="global-search-cross" (click)="clearSearchBox()">
                    <img src="../images/site-icons/cross-red.svg">
                </div>
            </div> -->
            <ul *ngFor="let location of locations; let i=index">
                <div class="row">
                    <div class="image-container" id="btnHelp" style="width: 20%">
                        <div class="nav_user whiten">
                            <img style="width: 30px; margin: 25px 20px;" src="../images/site-icons/black-red-icon/delivery-docket.svg">
                        </div>
                    </div>

                    <div style="width: 74%; margin: 10px;">
                        <div class="store-name">{{ location?.out_whse_description }}</div>
                        <div class="address">{{ location?.out_whse_address01 }} {{ location?.out_whse_address02 }} {{ location?.out_whse_address03 }} {{ location?.out_whse_address04 }} {{ location?.out_whse_state }} {{ location?.out_whse_postcode }}</div>
                        <div style="width: 80%">
                            <button [disabled]="location?.out_whse_code == currentStore?.out_whse_code" (click)="setMyStore(location)" class="button button-red button-mid addonbtn">Set as my store</button>
                        </div>
                    </div>
                </div>
            </ul>
        </ng-container>
    </form>
  </div>
</div>
 